import { ArrowBack } from "../icons/ArrowBack";
import { ArrowDown2 } from "../icons/ArrowDown";
import { Loading } from "../icons/Loading";

interface ButtonProps {
  children: React.ReactNode;
  color?: 'primary' | 'black' | 'white'| 'gray';
  small?: boolean;
  rounded?: boolean;
  loading?: boolean;
  full?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  className?: string;
}

interface ButtonBackProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

interface SmallBackButtonProps {
  label?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const CustomButton = ({
  children,
  color = 'primary',
  small = false,
  loading,
  full = false,
  rounded = false,
  disabled = false,
  type = 'button',
  onClick,
  className = '',
}: ButtonProps) => {
  const baseClass = 'flex select-none justify-center transition-colors duration-300 ease-in-out items-center focus:outline-none focus:ring-2 focus:ring-offset-2';

  const sizeClass = small ? 'px-4 py-2 text-sm' : 'px-6 py-4 text-sm w-full md:w-25 md:min-w-[255px]';
  const colorClass = color === 'primary'
    ? 'bg-primary text-white hover:bg-primaryDark'
    : color === 'black'
    ? 'bg-black text-white hover:bg-black-600'
    : color === 'white'
    ? 'bg-white shadow-md hover:bg-black-600 border border-primary text-primary hover:bg-[#ffcdf2]'
    : 'bg-[#F6F7F9] text-[#6B6B6B] hover:bg-grayLight2/30';
  const roundedClass = rounded ? 'rounded-full' : 'rounded-md';
  const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : '';
  const fullClass = full ? 'w-full' : '';


  const combinedClass = `${baseClass} ${sizeClass} ${colorClass} ${roundedClass} ${disabledClass} ${className} ${fullClass}`;

  return (
    <button
      type={type}
      className={combinedClass}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <Loading /> : children}
    </button>
  );
};

export const ButtonBack = ({
  children,
  onClick,
  className = '',
}: ButtonBackProps) => {
  const baseClass = 'flex items-center gap-4 focus:outline-none';

  const combinedClass = `${baseClass} ${className}`;

  return (
    <button
      type="button"
      className={combinedClass}
      onClick={onClick}
    >
      <ArrowBack />
      {children}
    </button>
  );
};

export const SmallBackButton = ({
  label = 'Go Back',
  onClick,
  className = '',
}: SmallBackButtonProps) => {
  const baseClass = 'w-10 aspect-square flex items-center justify-center text-primary transform rotate-90 rounded-full hover:bg-grayDefault focus:outline-none';

  const combinedClass = `${baseClass} ${className}`;

  return (
    <button
      type="button"
      className={combinedClass}
      onClick={onClick}
    >
      <ArrowDown2 />
      <span className="sr-only">{label}</span>
    </button>
  );
};
